import React, { useState, useEffect, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import './SocialPageAvatar.css';
import LiberiumLink from "./LiberiumLink";

const SocialPageAvatar = ({ page_id }) => {
    const [avatarUrl, setAvatarUrl] = useState(
        "https://peupleqc.com/s/liberium-public-img/peupleqc_favicon.ico"
    );
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchPageData = async () => {
            try {
                const pageResponse = await sdk.models.SocialPages.getOne(page_id);
                if (pageResponse && pageResponse.avatar) {
                    setAvatarUrl(
                        `https://peupleqc.com/s/peupleqc-upload/${pageResponse.avatar}`
                    );
                } else {
                    setError("Page non trouvée ou avatar non disponible");
                }
            } catch (err) {
                console.error("Erreur lors de la récupération des données :", err);
                setError("Erreur lors de la récupération des données de la page");
            }
        };

        if (page_id) {
            fetchPageData();
        }
    }, [page_id]);

    if (error) {
        return (
            <div className="social-page-avatar-error">
                {error}
            </div>
        );
    }

    return (
        <LiberiumLink href={`/page/${page_id}`}>
            <img
                src={avatarUrl}
                alt="Avatar de la page"
                className="social-page-avatar"
            />
        </LiberiumLink>
    );
};

export { SocialPageAvatar };
